import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  Assembly,
  AssemblyById,
  AvailabilitesProduct,
  Countries,
  CreateSupplierPayload,
  CreateAssemblyPayload,
  Incoming,
  IncomingData,
  IncomingNumber,
  Order,
  OrderBox,
  ProductOption,
  Suppliers,
  Warehouses,
} from './types'

export class WarehousesService {
  static getWarehouses(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Warehouses[]>> {
    return apiService.get<AxiosResponse<Warehouses[]>>(`/warehouses`, config)
  }

  static getAssembly(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Assembly>> {
    return apiService.get<AxiosResponse<Assembly>>(`/assembly/orders`, config)
  }

  static getAvailabilitiesProduct(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AvailabilitesProduct[]>> {
    return apiService.get<AxiosResponse<AvailabilitesProduct[]>>(
      `/products/availabilities`,
      { params: { ...config, withoutInventories: 1 } },
    )
  }

  static getProductOption(
    id: string,
  ): Promise<AxiosResponse<{ id: string; options: ProductOption[] }>> {
    return apiService.get<
      AxiosResponse<{ id: string; options: ProductOption[] }>
    >(`/products/available/${id}`)
  }

  static getAssemblyById(id: string): Promise<AxiosResponse<AssemblyById>> {
    return apiService.get<AxiosResponse<AssemblyById>>(`/assembly/${id}/items`)
  }

  static getOrderBox(): Promise<AxiosResponse<OrderBox>> {
    return apiService.get<AxiosResponse<OrderBox>>(`/order/boxes`)
  }

  static getProductByBarcode(barcode: string): Promise<AxiosResponse> {
    return apiService.get<AxiosResponse>(
      `/products/variation/barcode/${barcode}`,
    )
  }

  static getWarehouseID(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Incoming[]>> {
    return apiService.get<AxiosResponse<Incoming[]>>(`/incoming`, config)
  }

  static getVariation(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse> {
    return apiService.get<AxiosResponse>(
      `/products/available/${id}/variation`,

      { ...config },
    )
  }

  static getSuppliers(): Promise<AxiosResponse<Suppliers[]>> {
    return apiService.get<AxiosResponse<Suppliers[]>>(`/suppliers`)
  }

  static getCountries(): Promise<AxiosResponse<Countries[]>> {
    return apiService.get<AxiosResponse<Countries[]>>(`/countries`)
  }

  static createNewEntrance(data: Order): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/incoming/create`, data)
  }

  static deleteEntrance(
    listNumber: string,
    data: { incomingListNumber: string | undefined },
  ): Promise<AxiosResponse> {
    return apiService.deleteWithBody<AxiosResponse>(
      `/incoming/${listNumber}/remove`,
      data,
    )
  }

  static generateCSV(
    listNumber: string,
    data: {
      incomingListNumber: string | undefined
    },
  ): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(
      `/incoming/${listNumber}/generate-csv`,
      data,
    )
  }

  static creatingAnAssembly(
    orderId: string,
    data: CreateAssemblyPayload,
  ): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/assembly/${orderId}`, data)
  }

  static deferAssemblyOrder(
    orderId: string,
    isDeferred: boolean,
  ): Promise<AxiosResponse> {
    return apiService.patch<AxiosResponse>(`/assembly/${orderId}/deferred`, {
      isDeferred,
    })
  }

  static createSuppliers(
    data: CreateSupplierPayload,
  ): Promise<AxiosResponse<Suppliers>> {
    return apiService.post<AxiosResponse<Suppliers>>(`/suppliers`, data)
  }

  static accept(data: IncomingData): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(
      `/incoming/${data.incomingListNumber}/view/accept`,
      data,
    )
  }

  static getIncomingNumber(
    number: string,
  ): Promise<AxiosResponse<IncomingNumber>> {
    return apiService.get<AxiosResponse<IncomingNumber>>(
      `incoming/${number}/view`,
    )
  }

  static generateBarcode(id: string): Promise<Blob> {
    return apiService.get<Blob>(`/products/${id}/generateBarcode`, {
      responseType: 'blob',
    })
  }
}
